import momentHelper from 'scoreboard/components/moment-helper'
import i18n from 'scoreboard/components/i18n'

function notVisibleMessage(archiveDate, startDate) {
	let archive = momentHelper.formatDate(archiveDate)
	let start = momentHelper.formatDate(startDate)
	let message = ''
	if (archive != null && start != null) {
		message = i18n.get('scorecards.node.notVisibleBetween', start, archive)
	}
	if (archive == null && start != null) {
		message = i18n.get('scorecards.node.notVisibleBefore', start)
	}
	if (archive != null && start == null) {
		message = i18n.get('scorecards.node.notVisibleAfter', archive)
	}
	return message
}

export default notVisibleMessage

notVisibleMessage.__filename__ = 'scorecards/not-visible-message.js'
